export default __webpack_public_path__ + "static/winter28-f6211d4fff7e6d7ce3cd705f0c763849.webp";